<app-mens-intimate-wash>
  <p class="mb-4">
    Yeast infections can be persistent, and if you've had sexual intercourse during your episode, there's a chance the
    yeast could transfer to your partner's skin, increasing the risk of reinfection for both of you. To help ensure your
    recovery isn't interrupted, we offer a specially formulated
    <strong>Penile Bacteria Wash</strong> designed to eliminate any residual yeast and reduce the likelihood of
    reinfection.
  </p>
  <p class="mb-4">
    Using this wash daily for 5 days can help <strong>break the cycle of reinfection</strong>, ensuring that both you
    and your partner are clear of yeast, allowing for a smooth and complete recovery.
  </p>
</app-mens-intimate-wash>
